import styled from "styled-components"

export const FavoriteInternCardWrapp = styled.div`
  display: flex;
  justify-content: center;

  .intern-card {
    width: 100%;
    max-width: 340px;
    padding: 18px;
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #e7e2d8;
    box-shadow: none;
    transition: border-color 0.2s ease, transform 0.2s ease;

    &:hover {
      border-color: #b9c7b5;
      transform: translateY(-1px);
    }
    
    @media (max-width: 600px) {
      max-width: 100%;
      padding: 16px;
    }

    .content {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0;

      .logo-company {
        width: 48px;
        height: 48px;
        margin-right: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ebe6db;
        border-radius: 8px;
        background: #fbfaf7;
        flex-shrink: 0;

        img {
          max-width: 34px;
          max-height: 34px;
          object-fit: contain;
        }
      }

      .container-title {
        color: #28342f;

        .role {
          margin-top: 4px;
          font-size: 13px;
          color: #69716b;
          line-height: 1.4;
        }
      }
    }
  }
`
